import axios from 'axios'
import httpConfig from '../../../static/httpConfig'
import store from '../../vuex/store'
import router from '../../router/index'



const BASE_API = httpConfig.BASE_API
// 是否开发模式
const sw = process.env.NODE_ENV != 'production';

let serivce = axios.create({
    headers: {
        client: 'pc'
    },
    timeout: 15000
})

let httpCount = 0
serivce.interceptors.request.use(
    config => {
        httpCount++
        let i = config.url.includes('getMutiContentList.cmd')
        config.url = (sw ? '/api/' : BASE_API) + config.url
        store.commit('changeLoad', true)
        
        // console.log(config)
        if (config.url.includes('.do')) {
            config.headers['userId'] = localStorage.getItem('userId')
        }
        // console.log(config.headers)
        return config
    },
    error => {
        store.commit('changeLoad', false)
        return Promise.reject(error)
    }
)
serivce.interceptors.response.use(
    res => {


        if (res.data.code == 401) {
            store.commit('changeError', res.data.msg)
        }

        httpCount--
        if (httpCount == 0) {
            store.commit('changeLoad', false)
        }
        if (res.status === 200) {
            if (res.data.code === 401) {
                router.push({
                    path: '/401'
                })
            } else if (res.data.code === 500) {
                store.commit("changeMessage", '服务器错误!')
            } else {
                return res.data
            }
        }
    },
    error => {
        store.commit("changeMessage", '网络请求错误!')
        httpCount--
        store.commit('changeLoad', false)
        return Promise.reject(error) // 返回接口返回的错误信息
    }
)
export default serivce


// WEBPACK FOOTER //
// ./src/assets/js/https.js